import axios from 'axios'
import authHeader from '@/services/auth-header'

const baseUrl = process.env.VUE_APP_API_URL

class ImportedModulesService {
  getSguStructure ({ cycleId, areaId } = {}) {
    return axios.get(`${baseUrl}appscripts/sgu/structure`, {
      headers: authHeader(),
      params: { cycleId, areaId }
    })
  }

  getSguCscStructure ({ cycleId, areaId } = {}) {
    return axios.get(`${baseUrl}appscripts/sgu/csc/structure`, {
      headers: authHeader(),
      params: { cycleId, areaId }
    })
  }

  saveSguEvaluations (payload) {
    return axios.post(`${baseUrl}appscripts/sgu/evaluations`, this.sguEvaluationFormData(payload), {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    })
  }

  saveSguDraft (payload) {
    return axios.put(`${baseUrl}appscripts/sgu/evaluation-drafts`, this.sguEvaluationFormData(payload), {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    })
  }

  sguEvaluationFormData (payload) {
    const formData = new FormData()
    formData.append('cycleId', payload.cycleId)
    if (payload.areaId) formData.append('areaId', payload.areaId)
    formData.append('answers', JSON.stringify(payload.answers.map(answer => ({
      unitId: answer.unitId,
      requirementId: answer.requirementId,
      layer: answer.layer,
      justification: answer.justification || null,
      evidenceLink: answer.evidenceLink || null
    }))))
    payload.answers.forEach(answer => {
      const files = answer.files || []
      files.forEach(file => {
        formData.append(`attachments[${answer.requirementId}][]`, file)
      })
    })

    return formData
  }

  saveSguCscEvaluations (payload) {
    return axios.post(`${baseUrl}appscripts/sgu/csc/evaluations`, {
      cycleId: payload.cycleId,
      areaId: payload.areaId,
      unitId: payload.unitId,
      answers: payload.answers.map(answer => ({
        unitId: answer.unitId,
        requirementId: answer.requirementId,
        layer: answer.layer,
        justification: answer.justification || null,
        evidenceLink: answer.evidenceLink || null
      }))
    }, {
      headers: authHeader()
    })
  }

  saveSguCscDraft (payload) {
    return axios.put(`${baseUrl}appscripts/sgu/csc/evaluation-drafts`, {
      cycleId: payload.cycleId,
      areaId: payload.areaId,
      unitId: payload.unitId,
      answers: payload.answers.map(answer => ({
        unitId: answer.unitId,
        requirementId: answer.requirementId,
        layer: answer.layer,
        justification: answer.justification || null,
        evidenceLink: answer.evidenceLink || null
      }))
    }, {
      headers: authHeader()
    })
  }

  downloadSguAttachment (attachmentId) {
    return axios.get(`${baseUrl}appscripts/sgu/evaluation-attachments/${attachmentId}`, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }

  getSguDashboard (cycleId) {
    return axios.get(`${baseUrl}appscripts/sgu/dashboard`, {
      headers: authHeader(),
      params: { cycleId }
    })
  }

  getSguResponses (cycleId) {
    return axios.get(`${baseUrl}appscripts/sgu/responses`, {
      headers: authHeader(),
      params: { cycleId }
    })
  }

  getSguReport (cycleId, unitId) {
    const unitPath = unitId ? `/${unitId}` : ''
    return axios.get(`${baseUrl}appscripts/sgu/reports${unitPath}`, {
      headers: authHeader(),
      params: { cycleId }
    })
  }

  getSharedSguReport (uuid) {
    return axios.get(`${baseUrl}appscripts/sgu/reports/shared/${uuid}`, {
      headers: authHeader()
    })
  }

  downloadSguReport (cycleId, unitId) {
    const unitPath = unitId ? `/${unitId}` : ''
    return axios.get(`${baseUrl}appscripts/sgu/reports${unitPath}/pdf`, {
      headers: authHeader(),
      params: { cycleId },
      responseType: 'blob'
    })
  }

  downloadSharedSguReport (uuid) {
    return axios.get(`${baseUrl}appscripts/sgu/reports/shared/${uuid}/pdf`, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }

  publishSguReport (cycleId, unitId) {
    return axios.put(`${baseUrl}appscripts/sgu/reports/${unitId}/publication`, { cycleId }, {
      headers: authHeader()
    })
  }

  revokeSguReport (cycleId, unitId) {
    return axios.delete(`${baseUrl}appscripts/sgu/reports/${unitId}/publication`, {
      headers: authHeader(),
      data: { cycleId }
    })
  }

  updateSguResponse (evaluationId, payload) {
    return axios.put(`${baseUrl}appscripts/sgu/responses/${evaluationId}`, payload, {
      headers: authHeader()
    })
  }

  getSguParameterization (cycleId) {
    return axios.get(`${baseUrl}appscripts/sgu/parameterization`, {
      headers: authHeader(),
      params: { cycleId }
    })
  }

  createSguParameter (resource, payload) {
    return axios.post(`${baseUrl}appscripts/sgu/parameterization/${resource}`, payload, {
      headers: authHeader()
    })
  }

  updateSguParameter (resource, id, payload) {
    return axios.put(`${baseUrl}appscripts/sgu/parameterization/${resource}/${id}`, payload, {
      headers: authHeader()
    })
  }

  deleteSguParameter (resource, id) {
    return axios.delete(`${baseUrl}appscripts/sgu/parameterization/${resource}/${id}`, {
      headers: authHeader()
    })
  }

  validateForumCollaborators (collaborators) {
    return axios.post(`${baseUrl}appscripts/forum/collaborators/validate`, {
      collaborators
    }, {
      headers: authHeader()
    })
  }

  getForumDashboard () {
    return axios.get(`${baseUrl}appscripts/forum/dashboard`, {
      headers: authHeader()
    })
  }
}

export default new ImportedModulesService()
